import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Dashboard from './Dashboard';
import '../styles/TransactionHistory.css';

const TransactionHistory = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchDate, setSearchDate] = useState('');

  const fetchTransactions = async (date = '') => {
    setLoading(true);
    try {
      const url = `/backend/api/get_all_transactions.php${date ? '?date=' + date : ''}`;
      const res = await axios.get(url, { withCredentials: true });
      setTransactions(res.data || []);
    } catch (error) {
      console.error('Error fetching transactions:', error);
      setTransactions([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchTransactions();
  }, []);

  const handleDateSearch = () => {
    fetchTransactions(searchDate);
  };

  const handleClearSearch = () => {
    setSearchDate('');
    fetchTransactions();
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  };

  const calculateTotal = () => {
    return transactions.reduce((sum, t) => sum + parseFloat(t.amount || 0), 0).toFixed(2);
  };

  const getTransactionTypeColor = (type) => {
    if (type === 'Expense') return '#ff6b6b';
    if (type.includes('Payment')) return '#51cf66';
    return '#4dabf7';
  };

  return (
    <Dashboard>
      <div className="transaction-history-container">
        <h2 className="transaction-history-title">Transaction History</h2>
      
      <div className="transaction-search-section">
        <div className="date-search-container">
          <input
            type="date"
            value={searchDate}
            onChange={(e) => setSearchDate(e.target.value)}
            className="date-input"
            placeholder="Search by date"
          />
          <button onClick={handleDateSearch} className="search-btn">
            Search
          </button>
          {searchDate && (
            <button onClick={handleClearSearch} className="clear-btn">
              Clear
            </button>
          )}
        </div>
      </div>

      {loading ? (
        <div className="loading-message">Loading transactions...</div>
      ) : transactions.length === 0 ? (
        <div className="no-data-message">
          {searchDate ? `No transactions found for ${formatDate(searchDate)}` : 'No transactions found.'}
        </div>
      ) : (
        <div className="transaction-table-container">
          <table className="transaction-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Type</th>
                <th>Name</th>
                <th>Class</th>
                <th>Description</th>
                <th>Amount (₹)</th>
                <th>Mode</th>
                <th>Transaction ID</th>
                <th>Bill No.</th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((transaction, index) => (
                <tr key={index}>
                  <td>{formatDate(transaction.transaction_date)}</td>
                  <td>
                    <span 
                      className="transaction-type-badge"
                      style={{ backgroundColor: getTransactionTypeColor(transaction.transaction_type) }}
                    >
                      {transaction.transaction_type}
                    </span>
                  </td>
                  <td>{transaction.name}</td>
                  <td>{transaction.class_name}</td>
                  <td>{transaction.description || '-'}</td>
                  <td className="amount-cell">₹ {parseFloat(transaction.amount).toFixed(2)}</td>
                  <td>{transaction.transaction_mode || '-'}</td>
                  <td>{transaction.transaction_id || '-'}</td>
                  <td>{transaction.bill_number || '-'}</td>
                </tr>
              ))}
              <tr className="total-row">
                <td colSpan="5"><strong>Total</strong></td>
                <td colSpan="4"><strong>₹ {calculateTotal()}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
      </div>
    </Dashboard>
  );
};

export default TransactionHistory;

